import styled, { keyframes } from 'styled-components'
import { Spinner } from '../Spinner'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 10;
  animation: ${fadeIn} 0.2s ease-in;
`

const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 500;
`

export function LoadingOverlay({ message }) {
  return (
    <Overlay>
      <LoadingContent>
        <Spinner size="24px" />
        {message && <span>{message}</span>}
      </LoadingContent>
    </Overlay>
  )
}
